export function raidDuration(start: Date | null | undefined, end: Date | null | undefined) {
  if (!start || !end) return "Fehlende Zeiten";
  const startTime = start.getTime();
  const endTime = end.getTime();
  const diffMs = endTime - startTime;
  const diffMinutes = diffMs / 1000 / 60;
  return diffMinutes.toFixed(0).toString();
}